module.exports = __webpack_public_path__ + "c67b96ea5c11b945ff2726469f1b2702.png";